import { Directive } from "@angular/core";

@Directive({
  selector: '[disable-replacement]'
})
export class DisableReplacementDirective {}


